import React from "react";

export const introduction = (
	<div>
		<h4>Introduction</h4>
		<p>
			Welcome to the MLforALL help page! Leverage this as a resource to not only
			apply your knowledge of machine learning models, but to also supplement
			your understanding of the theory.
		</p>
	</div>
);

export const contactUs = (
	<div>
		<h4>Help Us Improve</h4>
		<p>
			Is there something that's not unclear, confusing, missing, or could use
			more detail? Please let us know:{" "}
			<a href="mailto: mlforall.cmu@gmail.com">mlforall.cmu@gmail.com</a>
		</p>
	</div>
);
